import axios from "axios";

const OPENIBAN_BASE = "https://openiban.com/validate";
const REQUEST_TIMEOUT_MS = 5000;

const normalizeIban = (iban) =>
  String(iban ?? "")
    .replace(/\s+/g, "")
    .trim();

export default class OpenIbanService {
  /**
   * Validação de IBAN via OpenIBAN considerando best-effort.
   * @returns {Promise<{ ok: true } | { ok: false, reason: "invalid" | "unavailable" }>}
   */
  async validate(iban) {
    const normalized = normalizeIban(iban);
    if (!normalized) {
      return { ok: false, reason: "invalid" };
    }

    try {
      const response = await axios({
        method: "get",
        url: `${OPENIBAN_BASE}/${encodeURIComponent(normalized)}`,
        params: { getBIC: true, validateBankCode: true },
        timeout: REQUEST_TIMEOUT_MS,
      });

      if (response.status < 200 || response.status >= 300) {
        return { ok: false, reason: "unavailable" };
      }

      if (response.data?.valid === true) {
        return { ok: true };
      }

      if (response.data?.valid === false) {
        return { ok: false, reason: "invalid" };
      }

      return { ok: false, reason: "unavailable" };
    } catch {
      return { ok: false, reason: "unavailable" };
    }
  }
}
